import React, {FunctionComponent} from 'react';
import {GeneralProvider} from "../../context/GeneralContext";
import {FullPagePreloader} from "../../components/FullPagePreloader/FullPagePreloader";
import {ActivityProvider} from "../../context/ActivityContext";
import {CompanyProvider} from "../../context/CompanyContext";
import {InvoiceProvider} from "../../context/InvoiceContext";
import {CustomerProvider} from "../../context/CustomerContext";
import {JobProvider} from "../../context/JobContext";
import {PageHeader} from "../../components/PageHeader/PageHeader";
import {FileProvider} from "../../context/FileContext";
import {TabsNavigation} from "./TabsNavigation/TabsNavigation";
import {MainContent} from "./MainContent/MainContent";
import {MiddlePagePreloader} from "../../components/MiddlePagePreloader/MiddlePagePreloader";

export const ActiveLinkPage: FunctionComponent = () => {
    return (
        <GeneralProvider>
            <FullPagePreloader/>
            <MiddlePagePreloader/>
            <div className='container'>
                <ActivityProvider>
                    <CompanyProvider>
                        <InvoiceProvider>
                            <CustomerProvider>
                                <JobProvider>
                                    <PageHeader/>
                                </JobProvider>
                            </CustomerProvider>
                        </InvoiceProvider>
                    </CompanyProvider>

                    <CompanyProvider>
                        <InvoiceProvider>
                            <FileProvider>
                                <TabsNavigation/>
                            </FileProvider>
                        </InvoiceProvider>
                    </CompanyProvider>

                    <main>
                        <MainContent/>
                    </main>
                </ActivityProvider>
            </div>
        </GeneralProvider>
    );
};